'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { useEffect } from 'react'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import PropTypes from 'prop-types'

export const ThirdPartyNotificationRecipientSelect = ({
  items = [],
  label = 'Third party case type',
  onChange = (val) => {
    console.log(val)
  },
  required = false,
  setOptions,
  setSelected,
  size = 'small',
  sx = {},
  value = '',
  testData = null
}: ThirdPartyNotificationRecipientSelectProps) => {
  const { fetchAllUsers, allUsers } = useLookupsStore()
  const { userId } = useAuthenticationStore()

  useEffect(() => {
    if (!testData && !allUsers?.length) {
      fetchAllUsers()
    }
  }, [fetchAllUsers, allUsers])

  useEffect(() => {
    if (allUsers && allUsers.length > 0) {
      // Map allUsers to option objects.
      const mappedOptions = allUsers.map((user: any) => ({
        label: `${user.emailAddress}`,
        value: user.userId,
        emailAddress: user.emailAddress
      }))
      setOptions(mappedOptions)

      // If a value prop is provided, use it to set the selected object.
      let selectedOption = mappedOptions.find((option: any) => option.value === value)
      selectedOption ??= mappedOptions.find((option: any) => option.value === userId)
      if (selectedOption) {
        setSelected(selectedOption)
        // If no explicit value was provided (empty entries), inform parent to populate
        if (!value) onChange(selectedOption)
      }
    }
  }, [allUsers, value])

  // Find the matching option object from items to pass to ReactSelectMenu
  const selectedOption = items.find((option: any) => option.value === value) || null

  return (
    <div data-testid="ThirdPartyNotificationRecipientSelect" style={{ ...sx }}>
      <ReactSelectMenu
        label={label}
        items={items}
        value={selectedOption}
        onChange={(e: any) => onChange(e)}
        searchable
        idLabelKey="value"
        showIdInResults={true}
        name="thirdPartyNotificationRecipient"
        size={size}
        required={required}
        menuZindex={9999999}
      />
    </div>
  )
}

type ThirdPartyNotificationRecipientSelectProps = {
  items?: any[]
  label?: string
  onChange?: (val: any) => void
  required?: boolean
  setOptions: (options: any[]) => void
  setSelected: (selected: any) => void
  size?: 'small' | 'medium' | 'large'
  sx?: object
  value?: string
  testData?: any
}

ThirdPartyNotificationRecipientSelect.propTypes = {
  items: PropTypes.array,
  label: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  setOptions: PropTypes.func,
  setSelected: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  sx: PropTypes.object,
  value: PropTypes.string,
  testData: PropTypes.any
}
